var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChimney(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M416 32H32C14.327 32 0 46.327 0 64V192C0 209.75 14.25 224 32 224V456C32 469.255 42.745 480 56 480H56C69.255 480 80 469.255 80 456V384H256V456C256 469.255 266.745 480 280 480H280C293.255 480 304 469.255 304 456V384H368V456C368 469.255 378.745 480 392 480H392C405.255 480 416 469.255 416 456V224C433.75 224 448 209.75 448 192V64C448 46.327 433.673 32 416 32ZM160 336H80V224H160V336ZM368 336H208V224H368V336ZM400 176H48V80H400V176Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChimney);
export default __webpack_public_path__ + "static/media/chimney.bb018b505ce51f056f86851b353a087d.svg";
export { ForwardRef as ReactComponent };